import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { HideLoder, LogInSchoolID, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function ImportBuildingRoom() {
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const BuildingRoomRef = useRef();
    const [fileName, setFileName] = useState({
        error: '',
        document: ''
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const navigate = useNavigate();
    const [csvError, setCsvError] = useState("");

    async function ImportBuildingRoomsCSV(e) {
        setLoading(true)
        setCsvError('');
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });

        e.preventDefault();

        const fileInput = BuildingRoomRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false);
            setFileName({ ...fileName, error: "First, import the CSV file.", document: '' });
            fileInput.value = "";
            return;
        }
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setLoading(false);
            setFileName({ ...fileName, error: validationMsg, document: "" });
            fileInput.value = "";
            return;
        }
        const filename = files.name;
        setFileName({ ...fileName, error: "", document: filename });

        const formdata = new FormData();
        formdata.append("file", files);
        formdata.append("schoolId", LogInSchoolID);

        ApiCmnHeadersPostCall(`/buildings/import-with-rooms`, formdata)
            .then(result => {
                const responseRs = JSON.parse(result);
                setLoading(false);
                if (responseRs.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'If there was any mismatched or invalid data, or any mismatched headers in your CSV, those entries would have been skipped.'} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        navigate('/building')
                    }, 4000);
                } else {
                    setCsvError(responseRs);
                    setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                    fileInput.value = "";
                    setFileName({ ...fileName, error: '', document: '' });
                }
                fileInput.value = "";
                setFileName({ ...fileName, error: '', document: '' });
            })
            .catch(error => {
                fileInput.value = "";
                setFileName({ ...fileName, error: '', document: '' });
                log.error('error', error)
            });
    }
    function ShowFileName(flag) {
        const fileInput = BuildingRoomRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }
        const filename = files.name;
        setFileName({ ...fileName, error: '', document: filename });
    }
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Buildings with Rooms</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure data accuracy when entering buildings with rooms, please download our CSV template file. Ensure that your columns match the template before importing your buildings and rooms into the system.
                </p>
                <div className="row pt-3 px-3">
                    <label className="pb-4 ps-0 text-justify" style={{ fontSize: "13px" }}>
                        <a onClick={() => downloadSampleCSV('buildingsWithRooms', 'Buildings_rooms')}
                            style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                            CLICK HERE
                        </a> {" "}
                        to download the template CSV file for buildings with rooms data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                    </label>
                    <div className="col-12">
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportBuildingRoomsCSV(e)}>
                                <input type="file" ref={BuildingRoomRef} name="rbuildingroom_file" id="BuildingRoomsFile" accept='.csv' onChange={(e) => ShowFileName(4)} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="BuildingRoomsFile"> Import Buildings with Rooms
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.document != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        {fileName.document && <label style={{ fontWeight: "600", color: 'green' }}>{fileName.document}</label>}
                        {fileName.error?.trim() != "" && <label className='redText'>{fileName.error}</label>}
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
